import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import withTranslations from '../../translations';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { clearFeedbacksAction } from '../../actions/feedback';

import {
  AUTO_HIDE_DURATION,
  infoMessages,
  decisionNotSendMessage,
  successMessages,
  importJobMessages,
  jobIsLockedMessage,
  noPicturesAreUploadedMessage,
  specialErrors,
  rateHasToBeDifferentMessage,
  rateIsProvidedMessage,
  requestHasBeenSentToApproverMessage,
  verifyJobMessages,
} from './constants';

import {
  Snackbar,
  SnackbarContent,
} from '../base';

const styles = theme => ({
  snackbar: {
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(2),
    },
  },
  snackbarContentInfo: {
    background: 'white',
    border: `2px solid ${theme.palette.secondary.main}`,
    color: theme.palette.secondary.main,
  },
  snackbarContentError: {
    background: theme.palette.error.light,
  },
  snackbarContentSuccess: {
    background: 'rgba(60, 118, 61, 0.8)',
  },
  close: {
    cursor: 'pointer',
  },
});

class FeedbackBar extends Component {
  handleClose = () => {
    this.props.actions.clearFeedbacks();
  }

  renderMessage = (feedback, gt, c) => {
    if (specialErrors.includes(feedback)) {
      return (
        <SnackbarContent
          className={c.snackbarContentError}
          message={<span id="generic-error-message">{gt.Feedback[feedback]}</span>}
        />
      );
    } else if (infoMessages.includes(feedback)) {
      return (
        <SnackbarContent
          className={c.snackbarContentInfo}
          message={<span id="generic-info-message">{gt.Feedback.authentication}</span>}
        />
      );
    } else if (requestHasBeenSentToApproverMessage.includes(feedback)) {
      return (
        <SnackbarContent
          className={c.snackbarContentInfo}
          message={<span id="generic-info-message">{gt.Feedback.requestHasBeenSentToApprover}</span>}
        />
      );
    } else if (successMessages.includes(feedback)) {
      return (
        <SnackbarContent
          className={c.snackbarContentSuccess}
          message={<span id="generic-success-message">{gt.Feedback.success}</span>}
        />
      );
    } else if (decisionNotSendMessage.includes(feedback)) {
      return (
        <SnackbarContent
          className={c.snackbarContentError}
          message={<span id="generic-success-message">{gt.Feedback.decisionNotSend}</span>}
        />
      );
    } else if (importJobMessages.includes(feedback)) {
      return (
        <SnackbarContent
          className={c.snackbarContentError}
          message={<span id="generic-error-message">{gt.Feedback.jobCostDoesNotExist}</span>}
        />
      )
    } else if (verifyJobMessages.includes(feedback)) {
      return (
        <SnackbarContent
          className={c.snackbarContentError}
          message={<span id="generic-error-message">{gt.Feedback.materialNumberBrandDoesNotExist}</span>}
        />
      )
    } else if (jobIsLockedMessage.includes(feedback)) {
      return (
        <SnackbarContent
          className={c.snackbarContentError}
          message={<span id="generic-error-message">{gt.Feedback.jobIsLocked}</span>}
        />
      )
    } else if (noPicturesAreUploadedMessage.includes(feedback)) {
      return (
        <SnackbarContent
          className={c.snackbarContentError}
          message={<span id="generic-error-message">{gt.Feedback.noPicturesAreUploaded}</span>}
        />
      )
    } else if (rateIsProvidedMessage.includes(feedback)) {
      return (
        <SnackbarContent
          className={c.snackbarContentSuccess}
          message={<span id="generic-success-message">{gt.Feedback.rateIsProvided}</span>}
        />
      )
    } else if (rateHasToBeDifferentMessage.includes(feedback)) {
      return (
        <SnackbarContent
          className={c.snackbarContentError}
          message={<span id="generic-error-message">{gt.Feedback.rateHasToBeDifferent}</span>}
        />
      )
    }else {
      return (
        <SnackbarContent
          className={c.snackbarContentError}
          message={<span id="generic-error-message">{gt.Feedback.error}</span>}
        />
      );
    }
  }

  render() {
    const { classes: c, gt, hasFeedbacks, feedback } = this.props;
    const isSpecial = specialErrors.includes(feedback);

    return (
      hasFeedbacks &&
      <Snackbar
        className={c.snackbar}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        open={hasFeedbacks}
        autoHideDuration={isSpecial ? AUTO_HIDE_DURATION + 4000 : AUTO_HIDE_DURATION}
        ContentProps={{
          'aria-describedby': 'feedback-message',
        }}
        onClose={this.handleClose}
      >
        {this.renderMessage(feedback, gt, c)}
      </Snackbar>
    )
  }
}

const mapStateToProps = state => ({
  hasFeedbacks: state.feedback && state.feedback.length > 0,
  feedback: state.feedback && state.feedback[0],
})

const mapDispatchToProps = dispatch => ({
  actions: {
    clearFeedbacks: bindActionCreators(clearFeedbacksAction, dispatch),
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withTranslations(FeedbackBar)));



// WEBPACK FOOTER //
// ./src/components/FeedbackBar/FeedbackBar.js